var map = {
	"./badge-icon-basic.svg": "GVdr",
	"./badge-icon-plus.svg": "0oa3",
	"./badge-icon-pro.svg": "UMLj",
	"./cart.svg": "Mf2p",
	"./check-circle.svg": "uSDh",
	"./checkmark.svg": "JRGF",
	"./chevron-bold.svg": "Mr27",
	"./chevron-light.svg": "nFe+",
	"./chevron-medium.svg": "eexZ",
	"./close.svg": "A3/u",
	"./coupon.svg": "UcH8",
	"./customizable.svg": "Z7v/",
	"./edit.svg": "M+nA",
	"./error.svg": "+XBX",
	"./exclamation-circle.svg": "UjD6",
	"./glowforge-icon.svg": "Vesn",
	"./heart.svg": "UpTi",
	"./img-placeholder.svg": "O6k7",
	"./info-circle.svg": "tdxZ",
	"./info.svg": "zAl2",
	"./lock.svg": "AyOZ",
	"./long-arrow-right.svg": "ZG8K",
	"./menu.svg": "q+0c",
	"./minus.svg": "gGGG",
	"./pencil-ruler.svg": "1bEN",
	"./play-button.svg": "GbSm",
	"./play-circle.svg": "W2xz",
	"./plus-solid.svg": "o7Sy",
	"./plus.svg": "TrvK",
	"./premium-gem.svg": "2zZN",
	"./proofgrade-badge.svg": "BX9o",
	"./proofgrade.svg": "PHoO",
	"./remove.svg": "F14E",
	"./save.svg": "F2n7",
	"./search.svg": "kIUi",
	"./sliders.svg": "Tnx9",
	"./spinner.svg": "UN0s",
	"./success.svg": "Ftyr",
	"./times-circle.svg": "YmtJ",
	"./trash.svg": "wg/+",
	"./warning.svg": "ZzLV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FxAI";